import React, { useEffect } from "react";
import "./Contacts.css";
import Aos from "aos";
import "aos/dist/aos.css";
import contacttimg from "../../icons/contactImg.png";
const Contacts = () => {
	useEffect(() => {
		Aos.init();
	}, []);
	return (
		<>
			<section class="contact">
				<div
					class="contact-form"
					data-aos="fade-right"
					data-aos-duration="1000"
				>
					<h1>
						Contact <span>Us</span>{" "}
					</h1>
					<p>
						How did you like seeing this website, you can tell me here & Want to
						know more about me then feel free to contact send the mail below
						Have a nice day!
					</p>
					<form action="https://formspree.io/f/mnqyvzzq" method="POST">
						<input
							type="text"
							name="name"
							placeholder="Your Name"
							required
							autoComplete="off"
							max="10"
						></input>
						<input
							type="email"
							name="email"
							id=""
							placeholder="Enter Email"
							required
							autoComplete="off"
						></input>
						<textarea
							name="Message"
							id=""
							cols="30"
							rows="10"
							placeholder="Your Message"
							autoComplete="off"
							min="10"
							required
						></textarea>
						<input type="submit" name="" value="Submit" class="btn"></input>
					</form>
				</div>
				<div class="contact-img">
					{" "}
					<img
						src={contacttimg}
						alt="img"
						data-aos="fade-left"
						data-aos-duration="1000"
					/>
				</div>
			</section>
		</>
	);
};

export default Contacts;
